import { FC } from 'react';
import {
  ConnectBalances,
  ConnectComponentsProvider,
  ConnectPayments,
} from '@stripe/react-connect-js';

import { useStripeConnect } from '../../hooks/useStripeConnect';

export const MerchantDashboard: FC = () => {
  const { stripeConnectInstance } = useStripeConnect();

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectBalances />
      <ConnectPayments />
    </ConnectComponentsProvider>
  );
};
